const LockIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_941_504)">
			<path
				d="M10.0026 1.66797C11.1077 1.66797 12.1675 2.10696 12.9489 2.88836C13.7303 3.66976 14.1693 4.72957 14.1693 5.83463V8.33463C14.8323 8.33463 15.4682 8.59803 15.937 9.06687C16.4059 9.53571 16.6693 10.1716 16.6693 10.8346V15.8346C16.6693 16.4977 16.4059 17.1336 15.937 17.6024C15.4682 18.0712 14.8323 18.3346 14.1693 18.3346H5.83594C5.1729 18.3346 4.53701 18.0712 4.06817 17.6024C3.59933 17.1336 3.33594 16.4977 3.33594 15.8346V10.8346C3.33594 10.1716 3.59933 9.53571 4.06817 9.06687C4.53701 8.59803 5.1729 8.33463 5.83594 8.33463V5.83463C5.83594 4.72957 6.27492 3.66976 7.05633 2.88836C7.83773 2.10696 8.89753 1.66797 10.0026 1.66797ZM10.0026 11.668C9.58212 11.6678 9.17713 11.8266 8.86881 12.1125C8.5605 12.3985 8.37164 12.7903 8.3401 13.2096L8.33594 13.3346C8.33594 13.6643 8.43369 13.9865 8.61682 14.2606C8.79996 14.5347 9.06025 14.7483 9.3648 14.8744C9.66934 15.0006 10.0045 15.0336 10.3278 14.9693C10.6511 14.905 10.948 14.7462 11.1811 14.5131C11.4142 14.2801 11.5729 13.9831 11.6372 13.6598C11.7016 13.3365 11.6685 13.0014 11.5424 12.6968C11.4163 12.3923 11.2026 12.132 10.9286 11.9489C10.6545 11.7657 10.3322 11.668 10.0026 11.668ZM10.0026 3.33464C9.33956 3.33464 8.70368 3.59803 8.23484 4.06687C7.766 4.53571 7.5026 5.17159 7.5026 5.83463V8.33463H12.5026V5.83463C12.5026 5.17159 12.2392 4.53571 11.7704 4.06687C11.3015 3.59803 10.6656 3.33464 10.0026 3.33464Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_941_504">
				<rect
					width="20"
					height="20"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
);

export default LockIcon;
